class ActiveMenuStorageService {
  private readonly ACTIVE_MENU = 'ACTIVE-MENU';

  public set activeMenu(value: string) {
    sessionStorage.setItem(this.ACTIVE_MENU, value);
  }

  public get activeMenu(): string {
    return sessionStorage.getItem(this.ACTIVE_MENU);
  }
}

export const activeMenuStorageService = new ActiveMenuStorageService();
